import { Box } from '@myn/mui';

import { Version } from '../../../types/versions.js';
import BudgetTable from './BudgetTable.jsx';
import ChannelMix from './ChannelMix.jsx';
import DateRange from './DateRange.jsx';
import VersionComment from './VersionComment.jsx';
import VersionKpi from './VersionKpi.jsx';

type IVersionDetailsInfoType = {
  item: Version;
  versions: Version[] | undefined;
};

const VersionDetailsInfo: React.FC<IVersionDetailsInfoType> = ({
  item,
  versions,
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 3,
      }}
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          <ChannelMix item={item} versions={versions} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexDirection: 'column',
            flexBasis: 360,
          }}
        >
          <DateRange item={item} />
          <BudgetTable item={item} versions={versions} />
        </Box>
      </Box>
      <VersionKpi item={item} />
      <VersionComment item={item} />
    </Box>
  );
};

export default VersionDetailsInfo;
